import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../../http/http.service';

export interface ChatChart {
  type: 'bar' | 'line';
  stacked?: boolean;
  horizontal?: boolean;
  title?: string;
  labels: string[];
  datasets: { label: string; data: number[] }[];
}

export interface ChatIaMessage {
  role: 'user' | 'assistant';
  content: string;
  chart?: ChatChart;
  html?: string;
  error?: boolean;
}

export interface ChatIaResponse {
  content: string;
  chart?: ChatChart;
  error: boolean;
  bloqueadoHasta: string | null;
}

export interface ChatIaInicio {
  sugerencias: string[];
  bloqueadoHasta: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ChatIaService {

  constructor(
    private httpClient: HttpService,
  ) {}

  public sendMessage(message: string, history: ChatIaMessage[] = []): Observable<ChatIaResponse> {
    return this.httpClient.post('llm/chat', { message, history }).pipe(
      map((res: any) => ({ content: res?.reply ?? '', chart: res?.chart, error: !!res?.error, bloqueadoHasta: res?.bloqueadoHasta ?? null })),
    );
  }

  public inicio(): Observable<ChatIaInicio> {
    return this.httpClient.get('llm/inicio') as Observable<ChatIaInicio>;
  }

  public habilitado(): Observable<boolean> {
    return this.httpClient.get('llm/estado').pipe(
      map((r: any) => !!r?.habilitado),
      catchError(() => of(false)),
    );
  }
}
